/**
 * Testimonial carousel
 *
 * - Prev / next navigation with wraparound
 * - Keyboard: ← → when focus is inside the carousel
 * - Arrows are hidden automatically when there is only 1 slide
 */
class Testimonial {
  constructor(el) {
    this.el       = el;
    this.slides   = [...el.querySelectorAll('.testimonial-carousel__slide')];
    this.controls = el.querySelector('.testimonial-carousel__controls');
    this.btnPrev  = el.querySelector('.testimonial-carousel__btn--prev');
    this.btnNext  = el.querySelector('.testimonial-carousel__btn--next');
    this.current  = 0;

    this._init();
  }

  _init() {
    if (!this.slides.length) return;

    // Find which slide is marked active in HTML (driven by JSON "active": true).
    // Fall back to the first slide if none is marked.
    const marked = this.slides.findIndex((s) => s.classList.contains('is-active'));
    this.current = marked >= 0 ? marked : 0;
    this.slides[this.current].classList.add('is-active');

    // Hide controls when there is only one slide — nothing to navigate
    if (this.slides.length <= 1) {
      if (this.controls) this.controls.hidden = true;
      return;
    }

    this.btnPrev.addEventListener('click', () => this._go(this.current - 1));
    this.btnNext.addEventListener('click', () => this._go(this.current + 1));

    // Keyboard navigation when focus is anywhere inside the carousel
    this.el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  this._go(this.current - 1);
      if (e.key === 'ArrowRight') this._go(this.current + 1);
    });
  }

  _go(index) {
    const count = this.slides.length;
    const next  = (index + count) % count; // wrap around

    this.slides[this.current].classList.remove('is-active');
    this.slides[next].classList.add('is-active');
    this.current = next;
  }
}

// Self-initialise
document.querySelectorAll('[data-testimonial-carousel]').forEach((el) => {
  new Testimonial(el);
});

export default Testimonial;
